<!--
 * @Author: your name
 * @Date: 2020-02-26 21:55:59
 * @LastEditTime: 2020-04-10 10:40:19
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /xkxy_front/src/components/Result1.vue
 -->
<template>
  <div class="result3">
    <div class="header">
        <img src="../assets/head4.png">
        <div class="title">
          <p class="title_1">SCL90自测量表评测结果</p>
        </div>
    </div>

    <div class="body">
        <div class="part_1">
            <p>结果分析</p>
            <van-row class="result">
                <van-col span="8">类型</van-col>
                <van-col span="8">平均分</van-col>
                <van-col span="8">总分</van-col>
            </van-row>
            <van-row class="result">
                <van-col span="8">躯体化</van-col>
                <van-col span="8">{{ p1 }}</van-col>
                <van-col span="8">{{ t1}}</van-col>
            </van-row>
            <van-row class="result">
                <van-col span="8">强迫症状</van-col>
                <van-col span="8">{{ p2 }}</van-col>
                <van-col span="8">{{ t2 }}</van-col>
            </van-row>
            <van-row class="result">
                <van-col span="8">人际关系敏感</van-col>
                <van-col span="8">{{ p3 }}</van-col>
                <van-col span="8">{{ t3 }}</van-col>
            </van-row>
             <van-row class="result">
                <van-col span="8">抑郁</van-col>
                <van-col span="8">{{ p4 }}</van-col>
                <van-col span="8">{{ t4 }}</van-col>
            </van-row>
             <van-row class="result">
                <van-col span="8">焦虑</van-col>
                <van-col span="8">{{ p5 }}</van-col>
                <van-col span="8">{{ t5 }}</van-col>
            </van-row>
             <van-row class="result">
                <van-col span="8">敌对</van-col>
                <van-col span="8">{{ p6 }}</van-col>
                <van-col span="8">{{ t6 }}</van-col>
            </van-row>
             <van-row class="result">
                <van-col span="8">恐怖</van-col>
                <van-col span="8">{{ p7 }}</van-col>
                <van-col span="8">{{ t7 }}</van-col>
            </van-row>
             <van-row class="result">
                <van-col span="8">偏执</van-col>
                 <van-col span="8">{{ p8 }}</van-col>
                <van-col span="8">{{ t8 }}</van-col>
            </van-row>
               <van-row class="result">
                <van-col span="8">精神病性</van-col>
                <van-col span="8">{{ p9 }}</van-col>
                <van-col span="8">{{ t9 }}</van-col>
            </van-row>
               <van-row class="result">
                <van-col span="8">其他</van-col>
               <van-col span="8">{{ p10 }}</van-col>
                <van-col span="8">{{ t10 }}</van-col>
            </van-row>
            <van-row class="result">
                <van-col span="8">总分</van-col>
               <van-col span="8">{{ p11 }}</van-col>
                <van-col span="8">{{ t11 }}</van-col>
            </van-row>

            <p>按中国常模结果，如果您的SCL90测试总分超过160分，单项均分超过2分就应作进一步检查，标准分为大于200分说明您有明显心里问题的可能性，可求助于心理咨询，大于250分则比较严重，需要作医学上的详细检查，很可能要做针对性的心理治疗或在医生的指导下服药。</p>
        </div>

        <div class="part_2">
            <p class="colorBlue">本测试仅供参考</p>
            <p class="colorBlue">你是否需要专业咨询为您服务</p>
            <p class="yes" @click="goApply()">是</p>
            <p class="no" @click="goIndex()">否</p>
        </div>
    </div>
     <div class="footer3"  @click="goback()">
      <img class="goback" src="../assets/goback.png" >
    </div>
    <share></share>
  </div>
</template>

<script>
import { Http } from '@/utils/http.js'
import api   from '@/config/api.js'
// import validator from '@/utils/validator.js'
import Cookies from 'js-cookie'
// import AreaList from '@/utils/area'
// import { pca, pcaa } from 'area-data'
import axios from 'axios'


export default {
  name: 'Result2',
  data() {
    return {
        p1: 0,
        t1: 0,
        p2: 0,
        t2: 0,
        p3: 0,
        t3: 0,
        p4: 0,
        t4: 0,
         p5: 0,
        t5: 0,
         p6: 0,
        t6: 0,
         p7: 0,
        t7: 0,
         p8: 0,
        t8: 0,
         p9: 0,
        t9: 0,
         p10: 0,
        t10: 0,
         p11: 0,
        t11: 0,
    };
  },

  methods: {
      // 返回上一页
    goback(){
      this.$router.push({ name: "QuestionList"})
    },
      // 去申请页
    goApply(){
       this.$router.push({ name: "Apply"})
    },
    // 去首页
    goIndex(){
      this.$router.push({ name: "Index"})
    }
  },
  mounted: function() {
    this.p1 = this.$route.query.p1
    this.t1 = this.$route.query.t1
    this.p2 = this.$route.query.p2
    this.t2 = this.$route.query.t2
    this.p3 = this.$route.query.p3
    this.t3 = this.$route.query.t3
    this.p4 = this.$route.query.p4
    this.t4 = this.$route.query.t4
    this.p5 = this.$route.query.p5
    this.t5 = this.$route.query.t5
    this.p6 = this.$route.query.p6
    this.t6 = this.$route.query.t6
    this.p7 = this.$route.query.p7
    this.t7 = this.$route.query.t7
    this.p8 = this.$route.query.p8
    this.t8 = this.$route.query.t8
    this.p9 = this.$route.query.p9
    this.t9 = this.$route.query.t9
    this.p10 = this.$route.query.p10
    this.t10 = this.$route.query.t10
    this.p11 = this.$route.query.p11
    this.t11 = this.$route.query.t11
  }

};
</script>

<style lang="less">
.result3 {
  font-size: 16px;
  .header {
    position: relative;
    img {
      width: 100%;
      display: block;
    }
    .title {
      .title_1 {
        position: absolute;
        width: 40%;
        top: 20px;
        font-size: 20px;
        left: 30px;
        color: #34afe8;
      }
    }
  }
  .body {
    margin-top: 12px;
    margin-left: 32px;
    margin-right: 32px;
     font-size: 12px;
    .part_1 {
        .fen {
            font-size: 24px;
            color: #34afe8;
        }
        .result {
            text-align: center;
            border-bottom-style: solid;
            padding-bottom: 6px;
            padding-top: 6px;
            text-align: center;
            border-width: 1px;
            border-color: #e8e3e3;
            }
    }
    .part_2 {
        text-align: center;
        box-shadow: 0 5px 10px #888888;
        padding-bottom: 12px;
        padding-top: 12px;
        width: 80%;
        margin: 0 auto;
        .colorBlue {
            color: #34afe8;
        }
        .yes {
            color: #fff;
            width: 48px;
            margin-left: 42%;
            background-color: #1199d8;
            border: 2px solid;
            border-radius: 25px;
        }
        .no {
            color: #fff;
            width: 48px;
            margin-left: 42%;
            background-color: #828d92;
            border: 2px solid;
            border-radius: 25px;
        }
    }
  }
   .footer3 {
      position: fixed;
      bottom: 0px;
      right: 0;
      img {
        width: 80px;
        background: #34afe8;
        border: 1px dotted #34afe8;
        -webkit-border-radius: 50%;
        border-radius: 10%;
      }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Result3.vue